import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { Button } from "../components/ui/button";
import { LOGO_URL, NAV_LINKS, CONTACT } from "../lib/content";

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-slate-900/85 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="container mx-auto flex items-center justify-between h-16 md:h-20 px-4 md:px-6">
        <a href="#top" data-testid="navbar-logo-link" className="flex items-center gap-3">
          <img
                src={LOGO_URL}
                alt="JAR Smart.Studio"
                className="h-18 w-64"
              />
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.replace("#", "")}`}
              className="text-sm text-slate-300 hover:text-orange-400 transition-colors font-medium"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Button
            asChild
            data-testid="navbar-cta-contact"
            className="hidden md:inline-flex bg-purple-700 hover:bg-purple-600 text-white font-semibold rounded-full px-5"
          >
            <a href="#contacto">Hablemos</a>
          </Button>
          <button
            data-testid="navbar-mobile-toggle"
            className="lg:hidden p-2 text-white"
            onClick={() => setOpen((s) => !s)}
            aria-label="Abrir menú"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="navbar-mobile-menu"
          className="lg:hidden bg-slate-900/95 backdrop-blur-xl border-t border-white/10"
        >
          <div className="container mx-auto px-4 py-4 flex flex-col gap-2">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${l.href.replace("#", "")}`}
                className="py-2 text-slate-200 hover:text-orange-400 font-medium"
              >
                {l.label}
              </a>
            ))}
            <Button
              asChild
              data-testid="mobile-cta-whatsapp"
              className="mt-2 bg-orange-600 hover:bg-orange-500 text-white font-semibold rounded-full"
            >
              <a href={CONTACT.whatsappUrl} target="_blank" rel="noreferrer">WhatsApp</a>
            </Button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
